// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"0c9b5039","247":"bfa59416","308":"277ad422","371":"9f715f14","503":"baaed979","911":"bc4b0cbc"}[chunkId] + ".chunk.css";
};